import React from "react";
import "./SubHeading.scss"

export interface SubHeadingProps {
    subheading?: any;
    fontSize?: any;
    fontWeight?: any;
    padding?: any;
    width?: any;
    style?: any;
}

export interface SubHeadingState {

}

class SubHeading extends React.Component<SubHeadingProps, SubHeadingState> {
    public static defaultProps = {
        fontSize: '1em',
        padding: 0
    }
    constructor(props: SubHeadingProps) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <div className="sub-heading" style={{ padding: this.props.padding, width: this.props.width, ...this.props.style }}>
                <h2 style={{ fontSize: this.props.fontSize, fontWeight: this.props.fontWeight }}>{this.props.subheading}</h2>
            </div>
        );
    }
}

export default SubHeading;